import { toNumber } from 'lodash';
import dayjs from '../../../helpers/dates';
import { formatCurrencyOnBlur } from '../../../helpers/utils';

export const getClientAwardsExcelData = (projects: any[]) => {
  const aggregates = projects.reduce(
    (acc, project) => {
      acc.total += 1;
      acc.amount += toNumber(project.amount_awarded);
      acc.hours += toNumber(project.actual_hours);
      return acc;
    },
    { total: 0, amount: 0, hours: 0 },
  );

  const clients = [...new Set(projects.map((p) => p.client_name))].join('; ');

  const aggregateSheet = [
    ['Aggregates'],
    ['Clients', clients],
    ['Total Projects', aggregates.total],
    [
      'Total Awarded Amount',
      formatCurrencyOnBlur(aggregates.amount.toString()),
    ],
    ['Total Actual Hours', aggregates.hours.toFixed(2)],
  ];

  const projectRows = projects.map((p) => {
    const amtRequested = toNumber(p.amount_requested);
    const amtAwarded = toNumber(p.amount_awarded);
    return [
      p.client_name || '',
      p.funder_name || '--',
      p.description || '',
      amtRequested ? formatCurrencyOnBlur(amtRequested.toString()) : '--',
      amtAwarded ? formatCurrencyOnBlur(amtAwarded.toString()) : '--',
      p.award_start ? dayjs(p.award_start).format('YYYY-MM-DD') : '--',
      p.award_end ? dayjs(p.award_end).format('YYYY-MM-DD') : '--',
    ];
  });

  const projectSheet = [
    [
      'Client',
      'Funder',
      'Project',
      'Amount Requested',
      'Amount Awarded',
      'Start Date',
      'End Date',
    ],
    ...projectRows,
  ];

  return [
    { name: 'Aggregates', data: aggregateSheet },
    { name: 'Projects', data: projectSheet },
  ];
};
